import PropTypes from "prop-types";
import React from "react";
import { Radio, Box, FormControlLabel } from "@mui/material";
import QuestionTextField from "./QuestionTextField";
import AnswersField from "./AnswersField";

const TrueOrFalseFields = ({
  disabled,
  answers,
  onCorrectAnswerChange,
  isSurvey,
  questionFilesList,
  setQuestionFilesList
}) => {
  return (
    <>
      <QuestionTextField
        questionFilesList={questionFilesList}
        setQuestionFilesList={setQuestionFilesList}
      />
      {!isSurvey && (
        <Box mt={6}>
          <AnswersField
            renderAnswers={() => (
              <Box display="flex">
                {answers &&
                  answers.map((answer, index) => (
                    <Box mr={3} key={index}>
                      <FormControlLabel
                        control={
                          <Radio
                            checked={answer.correct}
                            onChange={() => onCorrectAnswerChange(index)}
                            disabled={disabled}
                            color="primary"
                            inputProps={{
                              "data-qa": "answer-choices-radio-btn"
                            }}
                          />
                        }
                        label={answer.text}
                      />
                    </Box>
                  ))}
              </Box>
            )}
          />
        </Box>
      )}
    </>
  );
};

TrueOrFalseFields.propTypes = {
  disabled: PropTypes.bool,
  answers: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      correct: PropTypes.bool
    })
  ),
  onCorrectAnswerChange: PropTypes.func,
  isSurvey: PropTypes.bool,
  questionFilesList: PropTypes.array,
  setQuestionFilesList: PropTypes.func
};

export default TrueOrFalseFields;
